import React, { useState, ChangeEvent } from 'react';
import { FaSave } from 'react-icons/fa';
import Dates from '~/utils/dates';
import CurrencyInput from '~/components/Modules/CurrencyMask';
import './styles.css';

interface EditTeAclModalProps {
    item: { unit_id: number; year: number; month: number; price: number };
    onSave: (newPrice: number) => void;
    onCancel: () => void;
}

const EditTeAclModal: React.FC<EditTeAclModalProps> = ({ item, onSave, onCancel }) => {
    const [price, setPrice] = useState<number>(item.price || 0);

    function onChangeFloat(event: ChangeEvent<HTMLInputElement | HTMLSelectElement>, originalValue: any) {
        setPrice(Number(originalValue || 0));
    }

    function getMonthName(month: number) {
        month = Number(month);
        if (month===0) return 'Geral';
        return Dates._getNameMonth((month-1));
    }

    function handleSave() {
        if (!price || Number(price) <= 0) {
            alert('Por favor, insira um montante válido.');
            return;
        }
        onSave(Number(price));
    }

    return (
        <div className="price-modal-container">
            <div className="price-modal-header">
                <h3>Editar TE/ACL</h3>
            </div>

            <div className="price-modal-body">
                <div className="form-group">
                    <label>Ano:</label>
                    <input className="form-input" disabled value={item.year} />
                </div>
                <div className="form-group">
                    <label>Mês:</label>
                    <input className="form-input" disabled value={getMonthName(item.month)} />
                </div>
                <div className="form-group">
                    <label htmlFor="price">Montante (MWh):</label>
                    <CurrencyInput
                        id="price"
                        name="price"
                        placeholder="0,00"
                        onChangeValue={onChangeFloat}
                        value={price}
                        hideSymbol
                        className="form-input"
                    />
                </div>
            </div>

            <div className="price-modal-footer">
                <button className="btn-cancel" onClick={onCancel}>
                    Cancelar
                </button>
                <button className="btn-save" onClick={handleSave}>
                    <FaSave size={16} />
                    Salvar
                </button>
            </div>
        </div>
    );
};

export default EditTeAclModal;


